import { cloneDeep, get, isEmpty, isNil, map, merge, some } from 'lodash';
import userToken from 'containers/services/security/access-token-storage';
import { DEFAULT_LAWYER_CODE } from 'containers/RecapManagerPage/constants';
import { FEATURES } from 'features/features';
import {
  PROVISION_PRIORITY_CLAIM_ID,
  VICTIM_QUALITY_PASSENGER_ID,
} from 'services/constants';
import {
  getLiveDocumentViewUrl,
  openDocument,
} from 'containers/UploadDocuments/utils';
import * as featureService from 'features/fflip-helpers';
import { STATUS_REJECTED } from 'containers/LawyerFeeNote/constants';
import { VICTIM } from 'containers/data-structure';
import { appConfigListingTyping, VictimType } from 'typings/globalTypes';

export const filterStackHolder = (stackHolders: any) => {
  return isEmpty(stackHolders)
    ? []
    : stackHolders.filter(
        (el: any) => String(el.ItemKey) !== DEFAULT_LAWYER_CODE,
      );
};

export const isDesactivateIntervenant = (
  sagisLawyers: any,
  lawyerCode: any,
) => {
  return isNil(
    get(
      sagisLawyers?.find(
        (el: any) => String(el.ItemKey) === String(lawyerCode),
      ),
      'ItemKey',
      null,
    ),
  );
};

export const isNotRcRisk = (listings: any, claimNumber: string) => {
  const otherRcType = get(listings, 'rcType', []).map((el: any) => el.title);
  return some(
    otherRcType,
    (item: string) =>
      claimNumber.includes(item) || claimNumber.startsWith(item),
  );
};

export const getTokenFromUserStorage = () => {
  return get(userToken.get(), 'token');
};
export const constructUrl = (baseUrl: string) => {
  return !isNil(get(userToken.get(), 'token', null))
    ? baseUrl
    : `${baseUrl}?isIntervenant=true`;
};

export const addPriorityReasonProfession = (
  priorityReasonClaimId: number,
  hasProfession: boolean,
  listings: any,
) => {
  const commonCondition = !isNil(priorityReasonClaimId)
    ? featureService.hasFeature(FEATURES.PRIORITY_CLAIM) &&
      hasProfession &&
      priorityReasonClaimId !== PROVISION_PRIORITY_CLAIM_ID
    : featureService.hasFeature(FEATURES.PRIORITY_CLAIM) && hasProfession;
  const professionVictim = get(
    get(listings, 'priorityClaimReason', []).find(
      (el: any) => el.title === 'Profession Victime',
    ),
    'id',
  );

  return commonCondition ? professionVictim : undefined;
};

export const removeRejectedVictims = (victims: any) => {
  return victims.filter((el: any) =>
    !isEmpty(get(el, 'decision', {}))
      ? el.decision?.status != STATUS_REJECTED
      : true,
  );
};

export const validationVehicle = (vehicle: any) => {
  return vehicle.some((el: any) => {
    if (!isEmpty(el) && !Object.values(el).includes('')) {
      return true;
    } else {
      return false;
    }
  });
};

export const removeWhiteSpaceFromString = (value: string) => {
  if (!isNil(value) && value) {
    return value.trim();
  } else {
    return value;
  }
};
export const removeDeletedItems = (items: any) => {
  return items.filter((el: any) => !el.isDeleted);
};

export const removeDeletedAssignement = (assignment: any) => {
  return assignment.filter((item: any) => !get(item, 'isDeleted', false));
};

export const displayVehiclePassenger = (victim: VictimType) => {
  return (
    featureService.hasFeature(FEATURES.EVOLUTION_P4) &&
    String(get(victim, [VICTIM.QUALITY_KEY], '')) ===
      VICTIM_QUALITY_PASSENGER_ID
  );
};

export const formatTitleDocument = (index: number) => {
  return `Document ${index + 1}`;
};

export const constructUrlV2 = (baseUrl: string) => {
  return !isNil(get(userToken.get(), 'token', null))
    ? baseUrl
    : `${baseUrl}&isIntervenant=true`;
};

export const handleOpenDocument = (
  document: {
    documentumId: string;
    url: string | null;
  },
  requestGetDocByDocumentumId: Function,
) => () => {
  if (
    !isNil(get(document, 'documentumId', null)) &&
    featureService.hasFeature(FEATURES.DOCUMENTUM_JUDICIARY_STEPS)
  ) {
    requestGetDocByDocumentumId(
      getLiveDocumentViewUrl(
        '' as any,
        '',
        true,
        get(document, 'documentumId', null) as any,
      ),
    );
  } else {
    openDocument(get(document, 'url', null) as any)();
  }
};

export const updateItemInList = <T>(
  list: T[],
  predicate: (item: T) => boolean,
  updatedFields: Partial<T>,
): T[] => {
  return map(list, item =>
    predicate(item) ? merge(cloneDeep(item), updatedFields) : item,
  );
};

export const getLimitInvoiceIntervenant = (
  appConfigListing: appConfigListingTyping[],
) => {
  return Number(
    get(
      appConfigListing.find(
        (item: appConfigListingTyping) =>
          item.task === 'LIMIT_INVOICE_DATE_INTERVENANT',
      ),
      'value',
      null,
    ),
  );
};

export const getLimitInvoiceManager = (
  appConfigListing: appConfigListingTyping[],
) => {
  return Number(
    get(
      appConfigListing.find(
        (item: appConfigListingTyping) =>
          item.task === 'LIMIT_INVOICE_DATE_MANAGER',
      ),
      'value',
      null,
    ),
  );
};
export const getLimitValidationInvoiceManager = (
  appConfigListing: appConfigListingTyping[],
) => {
  return Number(
    get(
      appConfigListing.find(
        (item: appConfigListingTyping) =>
          item.task === 'LIMIT_INVOICE_DATE_MANAGER_VALIDATION',
      ),
      'value',
      null,
    ),
  );
};
